import { css } from 'styled-components';
import { VERTICAL_PADDING } from '../../constants';
import { type PropsWithTheme } from '../../styled';

export const columnGridMixin = ({
  theme: {
    column: { backgroundColor, borderColor, cornerRadius }
  }
}: PropsWithTheme) => css`
  position: relative;
  overflow: hidden;
  padding-bottom: ${VERTICAL_PADDING}px;
  border: 1px solid ${borderColor};
  background-color: ${backgroundColor};
  border-radius: ${cornerRadius}px;
`;
